const tickets = {
    en: {
        "tickets.title": "Tickets",
        "tickets.newTicket": "New Ticket",
        "tickets.subject": "Subject",
        "tickets.type": "Type",
        "tickets.priority": "Priority",
        "tickets.status": "Status",
        "tickets.user": "User",
        "tickets.created": "Created",
        "tickets.open": "Open",
        "tickets.problemType": "Problem Type",
        "tickets.selectType": "Select type",
        "tickets.ptPayment": "Payment",
        "tickets.ptTransportation": "Transportation",
        "tickets.ptDocuments": "Documents",
        "tickets.ptVehicle": "Vehicle",
        "tickets.ptOther": "Other",
        "tickets.selectPriority": "Select priority",
        "tickets.prLow": "Low",
        "tickets.prMedium": "Medium",
        "tickets.prHigh": "High",
        "tickets.attachments": "Attachments (optional)",
        "tickets.message": "Message",
        "tickets.shortSummary": "Short summary",
        "tickets.describeIssue": "Describe your issue",
        "tickets.createTicket": "Create Ticket",
        "tickets.noMessages": "No messages yet",
        "tickets.typeMessage": "Type a message…",
        "tickets.filesSelected": "file(s) selected",
        "tickets.statusOpen": "open",
        "tickets.statusInProgress": "in progress",
        "tickets.statusClosed": "closed",
    },
    ru: {
        "tickets.title": "Тикеты",
        "tickets.newTicket": "Новый тикет",
        "tickets.subject": "Тема",
        "tickets.type": "Тип",
        "tickets.priority": "Приоритет",
        "tickets.status": "Статус",
        "tickets.user": "Пользователь",
        "tickets.created": "Создан",
        "tickets.open": "Открыть",
        "tickets.problemType": "Тип проблемы",
        "tickets.selectType": "Выберите тип",
        "tickets.ptPayment": "Оплата",
        "tickets.ptTransportation": "Транспортировка",
        "tickets.ptDocuments": "Документы",
        "tickets.ptVehicle": "Автомобиль",
        "tickets.ptOther": "Другое",
        "tickets.selectPriority": "Выберите приоритет",
        "tickets.prLow": "Низкий",
        "tickets.prMedium": "Средний",
        "tickets.prHigh": "Высокий",
        "tickets.attachments": "Вложения (необязательно)",
        "tickets.message": "Сообщение",
        "tickets.shortSummary": "Краткое описание",
        "tickets.describeIssue": "Опишите вашу проблему",
        "tickets.createTicket": "Создать тикет",
        "tickets.noMessages": "Сообщений пока нет",
        "tickets.typeMessage": "Введите сообщение…",
        "tickets.filesSelected": "файл(ов) выбрано",
        "tickets.statusOpen": "открыт",
        "tickets.statusInProgress": "в работе",
        "tickets.statusClosed": "закрыт",
    },
    geo: {
        "tickets.title": "ტიკეტები",
        "tickets.newTicket": "ახალი ტიკეტი",
        "tickets.subject": "თემა",
        "tickets.type": "ტიპი",
        "tickets.priority": "პრიორიტეტი",
        "tickets.status": "სტატუსი",
        "tickets.user": "მომხმარებელი",
        "tickets.created": "შექმნილია",
        "tickets.open": "გახსნა",
        "tickets.problemType": "პრობლემის ტიპი",
        "tickets.selectType": "აირჩიეთ ტიპი",
        "tickets.ptPayment": "გადახდა",
        "tickets.ptTransportation": "ტრანსპორტირება",
        "tickets.ptDocuments": "დოკუმენტები",
        "tickets.ptVehicle": "ავტომობილი",
        "tickets.ptOther": "სხვა",
        "tickets.selectPriority": "აირჩიეთ პრიორიტეტი",
        "tickets.prLow": "დაბალი",
        "tickets.prMedium": "საშუალო",
        "tickets.prHigh": "მაღალი",
        "tickets.attachments": "დანართები (არასავალდებულო)",
        "tickets.message": "შეტყობინება",
        "tickets.shortSummary": "მოკლე აღწერა",
        "tickets.describeIssue": "აღწერეთ თქვენი პრობლემა",
        "tickets.createTicket": "ტიკეტის შექმნა",
        "tickets.noMessages": "შეტყობინებები ჯერ არ არის",
        "tickets.typeMessage": "დაწერეთ შეტყობინება…",
        "tickets.filesSelected": "ფაილი არჩეულია",
        "tickets.statusOpen": "ღია",
        "tickets.statusInProgress": "მიმდინარე",
        "tickets.statusClosed": "დახურული",
    },
};

export default tickets;
